import React, { useEffect, useState } from "react";
import Editor from "../../../components/form/Editor";
import Input from "../../../components/form/Input";
import Select from "../../../components/form/Select";
import useForm from "../../../hooks/useForm";
import Button from "../../../components/form/Button";
import useMutation from "../../../hooks/useMutation";
import { faqAddEdit } from "../../../services/faqService";
import Textarea from "../../../components/form/Textarea";

const validation = {
  title: { required: true, message: "Question is required" },
  description: { required: true, message: "Answer is required" },
};

const ManageFaq = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });
  const [formType, setFormType] = useState("steps");
  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
      setFormType(data?.parentId === null ? "heading" : "steps");
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await faqAddEdit({
        ...val,
        // categoryType: "faq",
        // type: "general",
        type: "faq",
        isParent: formType === "heading",
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <>
      <div className="mb-4 flex gap-2">
        <Button
          buttonLabel="Heading"
          buttonFunction={() => setFormType("heading")}
          buttonClasses={`!rounded-full !px-6 !h-10 border ${
            formType === "heading"
              ? "!bg-chestnut-rose !text-white"
              : "!bg-transparent !text-chestnut-rose"
          }`}
        />
        <Button
          buttonLabel="Steps"
          buttonFunction={() => setFormType("steps")}
          buttonClasses={`!rounded-full !px-6 !h-10 border ${
            formType === "steps"
              ? "!bg-chestnut-rose !text-white"
              : "!bg-transparent !text-chestnut-rose"
          }`}
        />
      </div>
      <form onSubmit={(event) => handleSubmit(event, mutate)}>
        <div className="grid grid-cols-4 gap-x-4 gap-y-4">
          {(formType === "heading" || formType === "steps") && (
            <>
              <div className="relative col-span-4">
                {/* <Editor
            label="FAQ Question"
            placeholder="What is the MemoryDoodle"
            value={values?.title}
            onChange={(val) =>
              handleChange({ target: { name: "title", value: val } })
            }
            {...formValidate(errors, "title")}
          /> */}
                <Textarea
                  label="FAQ Question"
                  inputPlaceholder="What is the MemoryDoodle"
                  inputName="title"
                  inputValue={values?.title}
                  onChange={handleChange}
                  {...formValidate(errors, "title")}
                />
              </div>
              <div className="relative col-span-4">
                {/* <Editor
            label="FAQ Answer"
            placeholder="The MemoryDoodle is"
            value={values?.description}
            onChange={(val) =>
              handleChange({
                target: { name: "description", value: val },
              })
            }
            {...formValidate(errors, "description")}
          /> */}
                <Textarea
                  label="Faq Answer"
                  inputPlaceholder="The MemoryDoodle is"
                  inputName="description"
                  inputValue={values?.description}
                  onChange={handleChange}
                  {...formValidate(errors, "description")}
                />
              </div>
            </>
          )}
          {formType === "steps" && (
            <>
              <div className="relative col-span-4">
                {/* <Select
                  label={"Status"}
                  placeholder="Select status"
                  selectedValue={values?.status}
                  dropdownData={[
                    { name: "Active", value: "published" },
                    { name: "InActive", value: "draft" },
                  ]}
                  setSelectedValue={(val) => {
                    handleChange({
                      target: { name: "status", value: val },
                    });
                  }}
                /> */}
                {/* <Input
            label="Active"
            inputPlaceholder={"Enter"}
            inputName="active"
            value={values?.active}
            onChange={handleChange}
            {...formValidate(errors, "active")}
          /> */}
              </div>
              {/* <div className="flex items-start gap-4">
          <Input
            label={"InActive"}
            inputPlaceholder={"Enter"}
            inputName="inActive"
            value={values?.inActive}
            onChange={handleChange}
            {...formValidate(errors, "inActive")}
          />
          <div className="w-full"></div>
        </div> */}
            </>
          )}
        </div>
        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType="submit"
              buttonLabel={"Save FAQ"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
            <Button
              buttonLabel={"Cancel"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              buttonFunction={close}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default ManageFaq;
